import { multiFranchiseAxios } from '../axios/multiFranchiseAxios';
import {
  AdminDeliverySheetQuery,
  AdminDeliverySheetResponse,
  DeliverySheetStatistics,
  AdminDeliverySheetDetail
} from "../../compiler/deliverySheet.interface";

/**
 * 📄 รายการ Delivery Sheets พร้อมการกรอง
 * GET /procurement/order/admin/delivery-sheet
 */
export const APIGetAdminDeliverySheets = async (
  params?: AdminDeliverySheetQuery
): Promise<AdminDeliverySheetResponse> => {
  // Filter out empty/undefined parameters
  const filteredParams: Record<string, any> = {};
  
  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        filteredParams[key] = value;
      }
    });
  }

  // URL encode Thai characters in driver_name
  if (filteredParams.driver_name) {
    filteredParams.driver_name = encodeURIComponent(filteredParams.driver_name);
  }

  const response = await multiFranchiseAxios.get('/procurement/order/admin/delivery-sheet', {
    params: filteredParams
  });
  return response.data;
};

/**
 * 📊 สถิติ Delivery Sheets
 * GET /procurement/order/admin/delivery-sheet/statistics/summary
 */
export const APIGetAdminDeliverySheetStatistics = async (): Promise<DeliverySheetStatistics> => {
  const response = await multiFranchiseAxios.get('/procurement/order/admin/delivery-sheet/statistics/summary');
  return response.data;
};

/**
 * 📝 รายละเอียด Delivery Sheet
 * GET /procurement/order/admin/delivery-sheet/:uuid?order_uuid=xxx
 * @param uuid - UUID ของ delivery_sheet
 * @param orderUuid - UUID ของ order (optional, ใช้เมื่อต้องการดูข้อมูลของ order ที่เฉพาะเจาะจง)
 */
export const APIGetAdminDeliverySheetDetail = async (
  uuid: string, 
  orderUuid?: string
): Promise<AdminDeliverySheetDetail> => {
  const params: Record<string, string> = {};
  if (orderUuid) {
    params.order_uuid = orderUuid;
  }
  
  const response = await multiFranchiseAxios.get(`/procurement/order/admin/delivery-sheet/${uuid}`, {
    params
  });
  const payload = response.data;
  return payload?.data && !payload.uuid ? payload.data : payload;
};
